import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tooltip"]

    connect() {
        this.hideTimeout = null
        this.isTooltipHovered = false
        this.isTriggerHovered = false
    }

    disconnect() {
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout)
        }
    }

    mouseEnterTrigger() {
        this.isTriggerHovered = true
        this.showTooltip()
    }

    mouseLeaveTrigger() {
        this.isTriggerHovered = false
        this.scheduleHide()
    }

    mouseEnterTooltip() {
        this.isTooltipHovered = true
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout)
            this.hideTimeout = null
        }
    }

    mouseLeaveTooltip() {
        this.isTooltipHovered = false
        this.scheduleHide()
    }

    showTooltip() {
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout)
            this.hideTimeout = null
        }

        if (this.hasTooltipTarget) {
            this.tooltipTarget.style.opacity = '1'
            this.tooltipTarget.style.pointerEvents = 'auto'
        }
    }

    scheduleHide() {
        this.hideTimeout = setTimeout(() => {
            if (!this.isTriggerHovered && !this.isTooltipHovered) {
                this.hideTooltip()
            }
        }, 100)
    }

    hideTooltip() {
        if (this.hasTooltipTarget) {
            this.tooltipTarget.style.opacity = '0'
            this.tooltipTarget.style.pointerEvents = 'none'
        }
    }
}